module.exports = __webpack_public_path__ + "img/digitizationRed.686848b5.jpg";